import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import Landing from '../Landing/Landing';
import Section from '../Section/Section';

const Router = () => {
  const hub = useSelector((state) => state.hub.hub);
  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <Route exact path="/" component={Landing} />

          <Route
            path={`/${hub.name}/section/:sectionName`}
            component={Section}
          />
          <Redirect to="/" />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
};

export default Router;
